import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCardModule } from "@angular/material/card";
import { MatBadgeModule } from "@angular/material/badge";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { DialogModule } from "primeng/dialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { ColorPickerModule } from "primeng/colorpicker";
import { ConfirmationService } from "primeng/api";
import { InputNumberModule } from "primeng/inputnumber";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { ListboxModule } from "primeng/listbox";

import { DistrictLookupComponent } from "../schoolsearch/district-lookup/district-lookup.component";
import { DataService_DistrictLookup } from "../schoolsearch/district-lookup/shared/data.service";
import { SchoolSearchComponent } from "./components/school-search.component";

const material = [MatButtonModule, MatButtonToggleModule, MatCardModule, MatTabsModule];
@NgModule({
	declarations: [SchoolSearchComponent, DistrictLookupComponent],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		DropdownModule,
		MultiSelectModule,
		PersonSelectorModule,
		TableModule,
		CalendarModule,
		material,
		ColorPickerModule,
		InputNumberModule,
		SchoolselectorModule,
		ListboxModule,
	],
	providers: [ConfirmationService, DataService_DistrictLookup],
})
export class SchoolSearchModule {}
